






























import { computed, defineComponent } from '@vue/composition-api';
import TaskGroup from '@/components/activity-module/task-module/task-group.vue';
import HeightAnimeContainer from '@/components/common/height-anime-container.vue';
import { useTaskStore, TaskGroupInfo } from '@/store/task';
import { storeToRefs } from 'pinia';
import { useTaskLastMonth } from '@/hooks/use-task-last-month';


export default defineComponent({
  name: 'TaskModule',
  components: {
    TaskGroup,
    HeightAnimeContainer,
  },
  setup() {
    const { init: initTaskLastMonth, hasLastMonthExchange } = useTaskLastMonth();
    initTaskLastMonth();
    const taskStore = storeToRefs(useTaskStore());
    // 上个月有兑换的排序 limit > special > basic
    const map2num = {
      limit: 3,
      special: 2,
      basic: 1,
    };
    function sortFn(a: TaskGroupInfo, b: TaskGroupInfo): number {
      return map2num[b.taskGroupType] - map2num[a.taskGroupType];
    }

    // 任务组列表
    const showTaskGroupList = computed(() => {
      // 展示的列表
      const showList = taskStore.showTaskGroupList.value;
      // 隐藏的列表
      const hideList = taskStore.taskGroupList.value.filter(item => !showList.includes(item));
      if (!hasLastMonthExchange.value) {
        // 上个月没有兑换的排序 basic > special > limit
        map2num.basic = 3;
        map2num.limit = 1;
      } else {
        // 上个月有兑换的排序 limit > special > basic
        map2num.basic = 1;
        map2num.limit = 3;
      }
      return {
        showList: showList.sort(sortFn), // 倒叙
        hideList: hideList.sort(sortFn), // 倒叙
      };
    });
    /** 是否展示所有任务完成提示 */
    const isShowAllTaskDoneTips = computed(() => taskStore.isCannoDoMoreTask.value);
    return {
      isShowAllTaskDoneTips,
      showTaskGroupList,
    };
  },
});

